define('SuiteCommerce.OrderStatus.OrderFinder.Order.Model',
  [
    'SuiteCommerce.OrderStatus.Utils',
    'Backbone'
  ],
  function define(
    Utils,
    Backbone
  ) {
    'use strict';
    return Backbone.Model.extend({
      urlRoot: '/app/site/hosting/scriptlet.nl?script=customscript_ns_sc_ext_sl_orderstatus_of&deploy=customdeploy_ns_sc_ext_sl_orderstatus_of',
      initialize: function initialize() {
        this.validation = {};
      },
      defaults: function defineDefaultsValues() {
        return {
          ordernumber: '',
          verificationfield: '',
          details: {}
        };
      },
      addValidationRuleForProperty: function addValidationRuleForProperty(field, rule) {
        if (!Object.prototype.hasOwnProperty.call(this.validation, field)) {
          this.validation[field] = [];
        }
        this.validation[field].push(rule);
      }
    });
  });
